// extracted by mini-css-extract-plugin
export default {"TextArea":"MultiSelectFieldConfig_TextArea__0sGXD"};